exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ghost{opacity:.5;background:#c8ebfb}.list-group{width:100%}.list-group-item{border:1px solid #ccc;padding:5px;cursor:all-scroll;margin-bottom:5px}.form-overlay{position:absolute;top:0;bottom:0;right:0;left:0;background:#fff;opacity:.5;z-index:4}", ""]);

// exports
